import { withMewsSrcSet } from '../Hoc';
import { MewsImageProps } from '../Hoc/MewsImageProps';
import { Image } from '../Image';

export default (props: MewsImageProps) => withMewsSrcSet(Image)(props);
